/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _ from 'lodash';
import { Typography } from '@material-ui/core';

const SECONDS_IN_MINUTE = 60;

class Counter extends React.Component {
  static propTypes = {
    minutesToCount: PropTypes.number.isRequired,
    minutesToWarn: PropTypes.number,
    onCountdownFinish: PropTypes.func,
  };

  static defaultProps = {
    minutesToWarn: 0,
    onCountdownFinish: () => {},
  };

  constructor(props) {
    super(props);

    this.state = {
      timeRemaining: props.minutesToCount * SECONDS_IN_MINUTE,
      warning: false,
    };
  }

  componentDidMount() {
    this.counterInterval = setInterval(() => {
      if (this.state.timeRemaining > 0) {
        this.setState((state, props) => ({
          timeRemaining: state.timeRemaining - 1,
          warning: state.timeRemaining <= props.minutesToWarn * SECONDS_IN_MINUTE,
        }));
      } else {
        clearInterval(this.counterInterval);
        this.props.onCountdownFinish();
      }
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.counterInterval);
  }

  counterInterval = undefined;

  formatTime = () => {
    const { timeRemaining } = this.state;
    const minutesRemaining = Math.floor(timeRemaining / SECONDS_IN_MINUTE);
    const secondsRemaining = timeRemaining % SECONDS_IN_MINUTE;
    return {
      minutesRemaining,
      secondsRemaining,
    };
  };

  render() {
    const { minutesRemaining, secondsRemaining } = this.formatTime();
    return (
      <CounterWrapper>
        <Typography variant="title">
Time Remaining
        </Typography>

        <Typography variant="title" color={this.state.warning ? 'error' : 'primary'}>
          {_.padStart(minutesRemaining, 2, '0')}
          :
          {_.padStart(secondsRemaining, 2, '0')}
        </Typography>
      </CounterWrapper>
    );
  }
}

export default Counter;

const CounterWrapper = styled.div`
  display: flex;
  align-items: center;

  & > * + * {
    margin-left: 20px !important;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Counter/Counter.js